module.exports = __webpack_public_path__ + "static/media/sliders.21fb8434.svg";